export const EMPLOYEE_STATUSES = {
	Active: 1,
	Inactive: 2,
	Terminated: 3,
	Retired: 4,
};
